import React, { Fragment } from 'react'
import { useReturnReason } from '../../../hooks/returnReason/useReturnReason'
import { Card, Col, Row, Button, CardBody, Input, Form } from 'reactstrap';
import { ModalReturnReason } from '../../../components/returnReason/ModalReturnReason';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexReturnReason = () => {

    const {
        listReturnReason,
        method, modalTitle, loading, modal, toggle, handleInputChange,
        handleCreate, saveCreate, handleUpdate, saveUpdate, handleDelete, saveDelete,
        id_return_reason, reason, validaciones,
        is_sample,
        is_work_order, is_tracking, is_send,
        loadingExport, handleExportReturnReason, handleSearch,
        searchReturnReason, handleClearReturnReason, closeDeleteAlert,
        modalAlert, showDeleteAlert
    } = useReturnReason();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_return_reason)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_return_reason)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };


    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                    <TitleDataTable
                                        titleTable="Motivo de Devoluciones"
                                        buttonActions={handleExportReturnReason}
                                        titleButton="Excel motivo de devoluciones"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear un motivo de devolución"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchReturnReason}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearReturnReason}

                                    />
                                </Col>

                                <div className="table-responsive">
                                    <DataTable
                                        value={listReturnReason}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="reason" header="Motivo o Razón" headerStyle={headerStyle} style={cellStyle} />
                                        <Column
                                            field="is_work_order"
                                            header="Orden"
                                            body={(rowData) => {

                                                const isWorkOrder = rowData.is_work_order === true || rowData.is_work_order === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: isWorkOrder ? "#ff9d00" : "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {isWorkOrder ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="is_sample"
                                            header="Toma"
                                            body={(rowData) => {

                                                const isToma = rowData.is_sample === true || rowData.is_sample === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: isToma ? "#ff9d00" : "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {isToma ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="is_send"
                                            header="Envios"
                                            body={(rowData) => {

                                                const isSend = rowData.is_send === true || rowData.is_send === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: isSend ? "#ff9d00" : "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {isSend ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column
                                            field="is_tracking"
                                            header="Análitica"
                                            body={(rowData) => {

                                                const istraking = rowData.is_tracking === true || rowData.is_tracking === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: istraking ? "#ff9d00" : "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {istraking ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                                <br />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <ModalReturnReason
                {
                ...{
                    method, modalTitle, loading, modal, toggle,
                    handleCreate, saveCreate, handleInputChange, handleUpdate, saveUpdate, handleDelete, saveDelete,
                    id_return_reason, reason, validaciones, is_sample, is_work_order, is_tracking, is_send
                }
                }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar motivo de devolución"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el tipo de devolución?"
                    alert1={true}
                    titleAlert1={reason}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    maskClassName="custom-total-mask"
                    newDesingDialog={true}
                    iconNewDialog="fa fa-trash-o f-20"
                    headerColor="#8b0000"
                    newDesingDialogDelete={true}
                    closable={false}
                />

            )}
        </Fragment>
    )
}
